import * as React from 'react';
import HomeBanner from '../Login/homepage_banner.jpg';
import LoginForm from './LoginForm';
import omanlogo from './OmanLogo.png';

function Loginbg (){
    return(
        <>
        <div className='container-fluid p-5 d-flex loginbg'>
         <div className='col-lg-4 col-sm-12  mt-5'>
         <LoginForm/>
         </div>
         <div className='col-lg-7 col-sm-12 text-center  logmainform'>

         {/* <div><img src={omanlogo} width="450"/></div>   */}

            {/* <img className='rounded-4 Regular shadow pt-2' src={HomeBanner} width="500" height="275"/> */}
            <img className='rounded-4 Regular shadow mt-3' src={HomeBanner} width="650" height="410"/>
         </div>

        </div>
        </>
    )
}
export default Loginbg;